import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TokenStorageService {

    constructor() { }

    private AccessToken: string = "";

    /**
     * Get access token
     * @returns {Observable<string>}
     */
    public getAccessToken(): Observable<string> {
        return Observable.of(this.AccessToken);
    }

    /**
     * Get refresh token
     * @returns {Observable<string>}
     */
    public getRefreshToken(): Observable<string> {
        const token: string = <string>localStorage.getItem('refreshToken');
        return Observable.of(token);
    }

    /**
     * Set access token
     * @returns {TokenStorage}
     */
    public setAccessToken(token: string): TokenStorageService {
        this.AccessToken = token;
        return this;
    }

    /**
    * Set refresh token
    * @returns {TokenStorage}
    */
    public setRefreshToken(token: string): TokenStorageService {
        localStorage.setItem('refreshToken', token);
        return this;
    }

    /**
    * Remove tokens
    */
    public clear() {
        this.AccessToken = "";
        localStorage.removeItem('refreshToken');
    }
}




// WEBPACK FOOTER //
// ./src/app/brightserve/token-storage.service.ts